import useTools from "@/use/Tools.js";

export default function useSharedSelectData() {

    const {$i18n} = useTools();

    const inputModes = [
        {id: "DATE_TO_DATE", name: $i18n.t('absence_request.DATE_TO_DATE')},
        {id: "DATE_TO_PERIOD", name: $i18n.t('absence_request.DATE_TO_PERIOD')},
        {id: "TIME_TO_TIME", name: $i18n.t('absence_request.TIME_TO_TIME')},
    ];

    const requestStatus = [
        {id: 'WAITING', name: "En attente"},
        {id: 'ACCEPT', name: "Accpté"},
        {id: 'REFUSE', name: "Refusé"},
    ];

    const contratStatus = [
        {id: 'ACTIVE', name: $i18n.t('contrat.ACTIVE')},
        {id: 'PENDING', name: $i18n.t('contrat.PENDING')},
        {id: 'ARCHIVE', name: $i18n.t('contrat.ARCHIVE')},
        {id: 'TERMINATED', name: $i18n.t('contrat.TERMINATED')},
    ];

    const contratTrialPeriodStatus = [
        {id: 'WITHOUT', name: $i18n.t('contrat.trial_period_status.WITHOUT')},
        {id: 'ACTIVE', name: $i18n.t('contrat.trial_period_status.ACTIVE')},
        {id: 'PENDING', name: $i18n.t('contrat.trial_period_status.PENDING')},
        {id: 'VALIDATED', name: $i18n.t('contrat.trial_period_status.VALIDATED')},
        {id: 'REJECTED', name: $i18n.t('contrat.trial_period_status.REJECTED')},
        {id: 'RENEWED', name: $i18n.t('contrat.trial_period_status.RENEWED')},
        {id: 'UNPROCESSED', name: $i18n.t('contrat.trial_period_status.UNPROCESSED')},
    ];

    const decisionStatus = [
        {id: 'WAITING', name: 'En attente'},
        {id: 'ACCEPT', name: 'Accpté'},
        {id: 'REFUSE', name: 'Refusé'},
    ];

    const workerStates = [
        {id: "ACTIVE", name: $i18n.t('worker.ACTIVE')},
        {id: "NO_ACTIVE", name: $i18n.t('worker.NO_ACTIVE')},
        {id: "PAY_ACTIVE", name: $i18n.t('worker.PAY_ACTIVE')},
        {id: "PAY_NO_ACTIVE", name: $i18n.t('worker.PAY_NO_ACTIVE')},
    ];

    const workerPhases = [
        {id: null, name: "Tous"},
        {id: "ACTIVE", name: $i18n.t('worker.PHASE_ACTIVE')},
        {id: "INACTIVE", name: $i18n.t('worker.PHASE_INACTIVE')},
    ];

    const profiles = [
        {id: 'MONTHLY', name: 'Mensuel'},
        {id: 'HORAIRE', name: 'Horaire'},
        {id: 'DAILY', name: 'Journalier'},
    ];

    const transferModes = [
        {id: "CCP", name: "Virement CCP"},
        {id: "BANK", name: "Virement Bancaire"},
        {id: "CHECK", name: "Chèque"},
        {id: "CASH", name: "Espèce"},
    ];

    const simpleOperators = [
        {id: 'equal', name: 'égale'},
        {id: 'lessThan', name: 'inférieur'},
        {id: 'lessThanOrEqualTo', name: 'inférieur ou égale'},
        {id: 'greaterThan', name: 'supérieur'},
        {id: 'greaterThanOrEqualTo', name: 'supérieur ou égale'},
    ];

    const operations = [
        {id: 'equal', name: '='},
        {id: 'notEqual', name: '<>'},
        {id: 'lessThan', name: '<'},
        {id: 'lessThanOrEqualTo', name: '<='},
        {id: 'greaterThan', name: '>'},
        {id: 'greaterThanOrEqualTo', name: '>='},
        {id: 'between', name: '> {V} <'},
        {id: 'betweenLeftSideEqualTo', name: '>= {V} <'},
        {id: 'betweenRightSideEqualTo', name: '> {V} <='},
        {id: 'betweenBothSideEqualTo', name: '>= {V} <='},
    ];

    const simpleOperations = [
        {id: 'equal', name: '='},
        {id: 'notEqual', name: '<>'},
        {id: 'lessThan', name: '<'},
        {id: 'lessThanOrEqualTo', name: '<='},
        {id: 'greaterThan', name: '>'},
        {id: 'greaterThanOrEqualTo', name: '>='},
    ];

    const yesOrNoArray = [
        {id: true, name: 'OUI'},
        {id: false, name: 'NON'}
    ];

    const periodicity = [
        {id: "YEARLY", name: "Année"},
        {id: "HALF_YEARLY", name: "Semestre"},
        {id: "MONTHLY", name: "Mois"},
        {id: "WEEKLY", name: "Semaine"},
        {id: "DAILY", name: "Jour"},
    ];

    const simplePeriodicity = [
        {id: "YEARLY", name: "Année"},
        {id: "MONTHLY", name: "Mois"},
        {id: "DAILY", name: "Jour"},
    ];

    const operators = ['=', '<>', '<', '<=', '>', '>=', '> et <', '>= et <', '> et <=', '>= et <='];

    const dataSelectModules = [
        {
            id: 'RECRUITMENT', name: $i18n.t('data_select.module.RECRUITMENT'), isDisabled: true, children: [
                {
                    id: 'RECRUITMENT_REQUEST', name: $i18n.t('data_select.module.sub.RECRUITMENT_REQUEST'), isDisabled: true, children: [
                        {id: 'RECRUITMENT_REQUESTING_AGENCY', name: $i18n.t('data_select.RECRUITMENT_REQUESTING_AGENCY'), module: '', subModule: ''},
                        {id: 'RECRUITMENT_BUDGET', name: $i18n.t('data_select.RECRUITMENT_BUDGET')},
                        {id: 'RECRUITMENT_REASON', name: $i18n.t('data_select.RECRUITMENT_REASON')},
                    ]
                },
                {
                    id: 'SOURCING', name: $i18n.t('data_select.module.sub.SOURCING'), isDisabled: true, children: [
                        {id: 'RECRUITMENT_CV_TECH_SPECIALITY', name: $i18n.t('data_select.RECRUITMENT_CV_TECH_SPECIALITY')},
                    ]
                },
                {
                    id: 'RECRUITMENT_PLANNING', name: $i18n.t('data_select.module.sub.RECRUITMENT_PLANNING'), isDisabled: true, children: [
                        {id: 'RECRUITMENT_PLANNING_TYPE', name: $i18n.t('data_select.RECRUITMENT_PLANNING_TYPE')},
                    ]
                },
            ]
        },
        {
            id: 'ADMIN', name: $i18n.t('data_select.module.ADMIN'), isDisabled: true, children: [
                {
                    id: 'OCCUPATION', name: $i18n.t('data_select.module.sub.OCCUPATION'), isDisabled: true, children: [
                        {id: 'SOCIO_PROFESSIONAL', name: $i18n.t('data_select.SOCIO_PROFESSIONAL')},

                    ]
                },
                {
                    id: 'WORKER', name: $i18n.t('data_select.module.sub.WORKER'), isDisabled: true, children: [
                        {id: 'WORKER_COMPANY', name: $i18n.t('data_select.WORKER_COMPANY')},
                        {id: 'WORKER_DEPARTMENT', name: $i18n.t('data_select.WORKER_DEPARTMENT')},
                        {id: 'WORKER_SERVICE', name: $i18n.t('data_select.WORKER_SERVICE')},
                        {id: 'WORKER_TEAM', name: $i18n.t('data_select.WORKER_TEAM')},
                        {id: 'WORKER_STATE', name: $i18n.t('data_select.WORKER_STATE')},
                        {id: 'WORKER_WORKPLACE', name: $i18n.t('data_select.WORKER_WORKPLACE')},
                        {id: 'WORKER_AFFILIATION', name: $i18n.t('data_select.WORKER_AFFILIATION')},
                        {id: 'WORKER_CNAS_AGENCY', name: $i18n.t('data_select.WORKER_CNAS_AGENCY')},
                        {id: 'WORKER_FAMILY_SITUATION', name: $i18n.t('data_select.WORKER_FAMILY_SITUATION')},
                        {id: 'WORKER_SCHOOL_SITUATION', name: $i18n.t('data_select.WORKER_SCHOOL_SITUATION')},
                        {id: 'WORKER_SICK_POSITION', name: $i18n.t('data_select.WORKER_SICK_POSITION')},
                        {id: 'WORKER_CATEGORIZATION', name: $i18n.t('data_select.WORKER_CATEGORIZATION')},
                        {id: 'MUTUAL_PRIME_TYPE', name: $i18n.t('data_select.MUTUAL_PRIME_TYPE')},
                        {id: 'MUTUAL_COMPANY', name: $i18n.t('data_select.MUTUAL_COMPANY')},
                        {id: 'WORKER_EXIT_REASON', name: $i18n.t('data_select.WORKER_EXIT_REASON')},
                    ]
                },
                {
                    id: 'CONTRAT', name: $i18n.t('data_select.module.sub.CONTRAT'), isDisabled: true, children: [
                        {id: 'CONTRAT_EXIT_RATIONALE', name: $i18n.t('data_select.CONTRAT_EXIT_RATIONALE')},
                        {id: 'CONTRAT_NATURE', name: $i18n.t('data_select.CONTRAT_NATURE')},

                    ]
                },
                {
                    id: 'REQUEST', name: $i18n.t('data_select.module.sub.REQUEST'), isDisabled: true, children: [
                        {id: 'CLAIM_TARGET', name: $i18n.t('data_select.CLAIM_TARGET')},
                        {id: 'ADMIN_REQUEST_TARGET', name: $i18n.t('data_select.ADMIN_REQUEST_TARGET')},
                    ]
                },
            ]
        },
        {
            id: 'TRAINING', name: $i18n.t('data_select.module.TRAINING'), isDisabled: true, children: [
                {
                    id: 'TRAINING_PARAM', name: $i18n.t('data_select.module.sub.TRAINING_PARAM'), isDisabled: true, children: [
                        {id: 'TRAINING_DOMAIN', name: $i18n.t('data_select.TRAINING_DOMAIN')},
                        {id: 'TRAINING_CATALOG_CATEGORY', name: $i18n.t('data_select.TRAINING_CATALOG_CATEGORY')},
                    ]
                },
            ]
        },
        {
            id: 'EVALUATION', name: $i18n.t('data_select.module.EVALUATION'), isDisabled: true, children: [
                {
                    id: 'EVALUATION_SKILL', name: $i18n.t('data_select.module.sub.EVALUATION_SKILL'), isDisabled: true, children: [
                        {id: 'EVALUATION_SKILL_CATALOG', name: $i18n.t('data_select.EVALUATION_SKILL_CATALOG')},
                        {id: 'EVALUATION_SKILL_CRITERION_CATEGORY', name: $i18n.t('data_select.EVALUATION_SKILL_CRITERION_CATEGORY')},
                    ]
                },
                {
                    id: 'EVALUATION_PERFORMANCE', name: $i18n.t('data_select.module.sub.EVALUATION_PERFORMANCE'), isDisabled: true, children: [
                        {id: 'EVALUATION_PERFORMANCE_CRITERION_CATEGORY', name: $i18n.t('data_select.EVALUATION_PERFORMANCE_CRITERION_CATEGORY')},
                    ]
                },
                {
                    id: 'EVALUATION_RECRUITMENT', name: $i18n.t('data_select.module.sub.EVALUATION_RECRUITMENT'), isDisabled: true, children: [
                        {id: 'EVALUATION_RECRUITMENT_CRITERION_CATEGORY', name: $i18n.t('data_select.EVALUATION_RECRUITMENT_CRITERION_CATEGORY')},
                    ]
                },
                {
                    id: 'EVALUATION_TRAINING_HOT', name: $i18n.t('data_select.module.sub.EVALUATION_TRAINING_HOT'), isDisabled: true, children: [
                        {id: 'EVALUATION_TRAINING_HOT_CRITERION_CATEGORY', name: $i18n.t('data_select.EVALUATION_TRAINING_HOT_CRITERION_CATEGORY')},
                    ]
                },
                {
                    id: 'EVALUATION_TRAINING_COLD', name: $i18n.t('data_select.module.sub.EVALUATION_TRAINING_COLD'), isDisabled: true, children: [
                        {id: 'EVALUATION_TRAINING_COLD_CRITERION_CATEGORY', name: $i18n.t('data_select.EVALUATION_TRAINING_COLD_CRITERION_CATEGORY')},
                    ]
                },
            ]
        },
        {
            id: 'DOCUMENT', name: $i18n.t('data_select.module.DOCUMENT'), isDisabled: true, children: [
                {
                    id: 'EDMS', name: $i18n.t('data_select.module.sub.GED'), isDisabled: true, children: [
                        {id: 'EDMS_TAG', name: $i18n.t('data_select.EDMS_TAG')},
                    ]
                },
            ]
        },
        {
            id: 'MEDICAL', name: $i18n.t('data_select.module.MEDICAL'), isDisabled: true, children: [
                {
                    id: 'MEDICAL_PARAM', name: $i18n.t('data_select.module.sub.MEDICAL_PARAM'), isDisabled: true, children: [
                        {id: 'MEDICAL_APPOINTMENT_RESULT', name: $i18n.t('data_select.MEDICAL_APPOINTMENT_RESULT')},
                        {id: 'MEDICAL_APPOINTMENT_STATE', name: $i18n.t('data_select.MEDICAL_APPOINTMENT_STATE')},
                    ]
                },
            ]
        },
        {
            id: 'PAY', name: $i18n.t('data_select.module.PAY'), isDisabled: true, children: [
                {
                    id: 'PAY_SLIP', name: $i18n.t('data_select.module.sub.PAY_SLIP'), isDisabled: true, children: [
                        {id: 'PAY_SLIP_TAG', name: $i18n.t('data_select.PAY_SLIP_TAG')},
                    ]
                },
            ]
        },
        {
            id: 'SOCIAL', name: $i18n.t('data_select.module.SOCIAL'), isDisabled: true, children: [
                {
                    id: 'CNAS', name: $i18n.t('data_select.module.sub.CNAS'), isDisabled: true, children: [
                        {id: 'CNAS_TYPE_DECLARATION', name: $i18n.t('data_select.CNAS_TYPE_DECLARATION')},
                        {id: 'CNAS_STATE_DECLARATION', name: $i18n.t('data_select.CNAS_STATE_DECLARATION')},
                        {id: 'CNAS_REFUND_TYPE', name: $i18n.t('data_select.CNAS_REFUND_TYPE')},
                        {id: 'CNAS_AGENCY', name: $i18n.t('data_select.CNAS_AGENCY')},
                    ]
                },
                {
                    id: 'SHIFA_CART', name: $i18n.t('data_select.module.sub.SHIFA_CART'), isDisabled: true, children: [
                        {id: 'SHIFA_CART_OPERATION', name: $i18n.t('data_select.SHIFA_CART_OPERATION')},
                        {id: 'SHIFA_CART_PRINTING_TYPE', name: $i18n.t('data_select.SHIFA_CART_PRINTING_TYPE')},
                        {id: 'SHIFA_CART_STATE', name: $i18n.t('data_select.SHIFA_CART_STATE')},
                    ]
                },
                {
                    id: 'DISEASE', name: $i18n.t('data_select.module.sub.DISEASE'), isDisabled: true, children: [
                        {id: 'DISEASE_SOURCE', name: $i18n.t('data_select.DISEASE_SOURCE')},
                        {id: 'DISEASE_CLASS', name: $i18n.t('data_select.DISEASE_CLASS')},
                        {id: 'DISEASE_NATURE', name: $i18n.t('data_select.DISEASE_NATURE')},
                        {id: 'DISEASE_STATE', name: $i18n.t('data_select.DISEASE_STATE')},
                    ]
                },
                {
                    id: 'CARE', name: $i18n.t('data_select.module.sub.CARE'), isDisabled: true, children: [
                        {id: 'CARE_FOLDER_STATE', name: $i18n.t('data_select.CARE_FOLDER_STATE')},
                        {id: 'CARE_FOLDER_NATURE', name: $i18n.t('data_select.CARE_FOLDER_NATURE')},
                    ]
                },
                {
                    id: 'BORDEREAU', name: $i18n.t('data_select.module.sub.BORDEREAU'), isDisabled: true, children: [
                        {id: 'BORDEREAU_TYPE', name: $i18n.t('data_select.BORDEREAU_TYPE')},
                        {id: 'BORDEREAU_MOVING_TYPE', name: $i18n.t('data_select.BORDEREAU_MOVING_TYPE')},
                    ]
                },
            ]
        },
    ];

    const dataSelectTypes = [
        {id: 'RECRUITMENT_REQUESTING_AGENCY', name: $i18n.t('data_select.RECRUITMENT_REQUESTING_AGENCY')},
        {id: 'RECRUITMENT_BUDGET', name: $i18n.t('data_select.RECRUITMENT_BUDGET')},
        {id: 'RECRUITMENT_REASON', name: $i18n.t('data_select.RECRUITMENT_REASON')},
        {id: 'RECRUITMENT_CV_TECH_SPECIALITY', name: $i18n.t('data_select.RECRUITMENT_CV_TECH_SPECIALITY')},


        {id: 'WORKER_COMPANY', name: $i18n.t('data_select.WORKER_COMPANY')},
        {id: 'WORKER_DEPARTMENT', name: $i18n.t('data_select.WORKER_DEPARTMENT')},
        {id: 'WORKER_SERVICE', name: $i18n.t('data_select.WORKER_SERVICE')},
        {id: 'WORKER_TEAM', name: $i18n.t('data_select.WORKER_TEAM')},
        {id: 'WORKER_STATE', name: $i18n.t('data_select.WORKER_STATE')},
        {id: 'WORKER_WORKPLACE', name: $i18n.t('data_select.WORKER_WORKPLACE')},
        {id: 'WORKER_AFFILIATION', name: $i18n.t('data_select.WORKER_AFFILIATION')},
        {id: 'WORKER_CNAS_AGENCY', name: $i18n.t('data_select.WORKER_CNAS_AGENCY')},
        {id: 'WORKER_FAMILY_SITUATION', name: $i18n.t('data_select.WORKER_FAMILY_SITUATION')},
        {id: 'WORKER_SCHOOL_SITUATION', name: $i18n.t('data_select.WORKER_SCHOOL_SITUATION')},
        {id: 'WORKER_SICK_POSITION', name: $i18n.t('data_select.WORKER_SICK_POSITION')},
        {id: 'WORKER_CATEGORIZATION', name: $i18n.t('data_select.WORKER_CATEGORIZATION')},
        {id: 'MUTUAL_PRIME_TYPE', name: $i18n.t('data_select.MUTUAL_PRIME_TYPE')},
        {id: 'MUTUAL_COMPANY', name: $i18n.t('data_select.MUTUAL_COMPANY')},
        {id: 'WORKER_EXIT_REASON', name: $i18n.t('data_select.WORKER_EXIT_REASON')},

        {id: 'CONTRAT_EXIT_RATIONALE', name: $i18n.t('data_select.CONTRAT_EXIT_RATIONALE')},
        {id: 'CONTRAT_NATURE', name: $i18n.t('data_select.CONTRAT_NATURE')},

        {id: 'CLAIM_TARGET', name: $i18n.t('data_select.CLAIM_TARGET')},
        {id: 'ADMIN_REQUEST_TARGET', name: $i18n.t('data_select.ADMIN_REQUEST_TARGET')},

        {id: 'PAY_SLIP_TAG', name: $i18n.t('data_select.PAY_SLIP_TAG')},

        {id: 'CNAS_TYPE_DECLARATION', name: $i18n.t('data_select.CNAS_TYPE_DECLARATION')},
        {id: 'CNAS_STATE_DECLARATION', name: $i18n.t('data_select.CNAS_STATE_DECLARATION')},
        {id: 'CNAS_REFUND_TYPE', name: $i18n.t('data_select.CNAS_REFUND_TYPE')},
        {id: 'CNAS_AGENCY', name: $i18n.t('data_select.CNAS_AGENCY')},

        {id: 'SHIFA_CART_OPERATION', name: $i18n.t('data_select.SHIFA_CART_OPERATION')},
        {id: 'SHIFA_CART_PRINTING_TYPE', name: $i18n.t('data_select.SHIFA_CART_PRINTING_TYPE')},
        {id: 'SHIFA_CART_STATE', name: $i18n.t('data_select.SHIFA_CART_STATE')},

        {id: 'DISEASE_SOURCE', name: $i18n.t('data_select.DISEASE_SOURCE')},
        {id: 'DISEASE_CLASS', name: $i18n.t('data_select.DISEASE_CLASS')},
        {id: 'DISEASE_NATURE', name: $i18n.t('data_select.DISEASE_NATURE')},
        {id: 'DISEASE_STATE', name: $i18n.t('data_select.DISEASE_STATE')},

        {id: 'CARE_FOLDER_STATE', name: $i18n.t('data_select.CARE_FOLDER_STATE')},
        {id: 'CARE_FOLDER_NATURE', name: $i18n.t('data_select.CARE_FOLDER_NATURE')},

        {id: 'BORDEREAU_TYPE', name: $i18n.t('data_select.BORDEREAU_TYPE')},
        {id: 'BORDEREAU_MOVING_TYPE', name: $i18n.t('data_select.BORDEREAU_MOVING_TYPE')},

        {id: 'TRAINING_DOMAIN', name: $i18n.t('data_select.TRAINING_DOMAIN')},
        {id: 'TRAINING_CATALOG_CATEGORY', name: $i18n.t('data_select.TRAINING_CATALOG_CATEGORY')},

        {id: 'MEDICAL_APPOINTMENT_RESULT', name: $i18n.t('data_select.MEDICAL_APPOINTMENT_RESULT')},
        {id: 'MEDICAL_APPOINTMENT_STATE', name: $i18n.t('data_select.MEDICAL_APPOINTMENT_STATE')},
    ];

    const careBeneficiaries = [
        {id: 'ASCENDANTS', name: 'Ascendants'},
        {id: 'INSURED', name: 'Assuré'},
        {id: 'SPOUSE', name: 'Conjoint'},
        {id: 'CHILD', name: 'Enfant'},
    ];

    const importModelTypes = [
        {id: 'PAY', name: 'Modèle de Paie'},
    ];

    const validationWorkFlowStatus = [
        {id: "WAITING", name: $i18n.t('request_workflow.WAITING')},
        {id: "IN_PROGRESS", name: $i18n.t('request_workflow.IN_PROGRESS')},
        {id: "ACCEPT", name: $i18n.t('request_workflow.ACCEPT')},
        {id: "REFUSE", name: $i18n.t('request_workflow.REFUSE')},
    ];

    const workFlowModules = [
        {id: "ABSENCE_REQUEST", name: $i18n.t('module.absence_request')},
        {id: "CLAIM", name: $i18n.t('module.claim')},
        {id: "ADMIN_REQUEST", name: $i18n.t('module.admin_request')},
        {id: "DEBT", name: $i18n.t('module.debt')},
        {id: "RECRUITMENT_REQUEST", name: $i18n.t('module.recruitment_request')},
        {id: "PAY_SLIP_ANNEX", name: $i18n.t('module.pay_slip_annex')},
        {id: "TRAINING_REQUEST", name: $i18n.t('module.training_request')},
    ];

    const recruitmentStates = [
        {id: "VALIDATION", name: $i18n.t('recruitment_request.VALIDATION')},
        {id: "SOURCING", name: $i18n.t('recruitment_request.SOURCING')},
        {id: "PLANNING", name: $i18n.t('recruitment_request.PLANNING')},
        {id: "EVALUATION", name: $i18n.t('recruitment_request.EVALUATION')},
        {id: "PENDING", name: $i18n.t('recruitment_request.PENDING')},
        {id: "CLOSED", name: $i18n.t('recruitment_request.CLOSED')},
    ];

    const recruitmentExpertDecisions = [
        {id: "YES", name: $i18n.t('common.accept')},
        {id: "NO", name: $i18n.t('common.refuse')},
    ];

    const boardingCategories = [
        {id: "ON", name: $i18n.t('boarding.ON')},
        {id: "OFF", name: $i18n.t('boarding.OFF')},
        // {id: "CROSS", name: $i18n.t('boarding.CROSS')},
    ];

    const boardingChronologies = [
        {id: "BEFORE_WORKER_ARRIVES", name: $i18n.t('boarding.BEFORE_WORKER_ARRIVES')},
        {id: "AFTER_WORKER_ARRIVES", name: $i18n.t('boarding.AFTER_WORKER_ARRIVES')},
    ];

    const boardingExecutions = [
        {id: "WORKER", name: $i18n.t('boarding.WORKER')},
        {id: "MANAGER", name: $i18n.t('boarding.MANAGER')},
        {id: "ORGANIZATIONAL_CHART", name: $i18n.t('boarding.ORGANIZATIONAL_CHART')},
        {id: "SPECIFIC", name: $i18n.t('boarding.SPECIFIC')},
    ];

    const boardingStatus = [
        {id: "TO_TREAT", name: $i18n.t('boarding.TO_TREAT')},
        {id: "IN_PROGRESS", name: $i18n.t('boarding.IN_PROGRESS')},
        {id: "FINISHED", name: $i18n.t('boarding.FINISHED')},
    ];

    const cvTechSourcingStates = [
        {id: "WAITING", name: $i18n.t('cv_tech_sourcing.WAITING')},
        {id: "PRE_SELECTED", name: $i18n.t('cv_tech_sourcing.PRE_SELECTED')},
        {id: "SELECTED", name: $i18n.t('cv_tech_sourcing.SELECTED')},
        {id: "RECOMMEND", name: $i18n.t('cv_tech_sourcing.RECOMMEND')},
        {id: "REJECTED", name: $i18n.t('cv_tech_sourcing.REJECTED')},
        {id: "FILTERED", name: $i18n.t('cv_tech_sourcing.FILTERED')},
        {id: "INCOMPLETE", name: $i18n.t('cv_tech_sourcing.INCOMPLETE')},
    ];


    const recruitmentScopes = [
        {id: "INTERNAL", name: $i18n.t('recruitment_request.INTERNAL')},
        {id: "EXTERNAL", name: $i18n.t('recruitment_request.EXTERNAL')},
    ];

    const recruitmentEvaluationDecisions = [
        {id: "YES", name: $i18n.t('recruitment_request.evaluation_decision_YES')},
        {id: "NO", name: $i18n.t('recruitment_request.evaluation_decision_NO')},
    ];

    const variables = [
        "[#DATE JOUR#]",
        "[#RAISON SOCIALE#]",
        "[#SOCIETE ADRESSE#]",
        "[#NUMÉRO ADHÉRENT#]",
        "[#CAPITALE SOCIALE#]",
        "[#SOCIETE ADRESSE 1#]",
        "[#SOCIETE ADRESSE 2#]",
        "[#SOCIETE TELEPHONE#]",
        "[#SOCIETE FAX#]",
        "[#SOCIETE EMAIL#]",
        "[#SOCIETE GPS#]",
        "[#SOCIETE SITE WEB#]",
        "[#SOCIETE ID FISCAL#]",
        "[#SOCIETE NIS#]",
        "[#SOCIETE ARTICLE D'IMPOSITION#]",
        "[#SOCIETE RC#]",
        "[#SOCIETE RIB#]",
        "[#SOCIETE COMPTE 1#]",
        "[#SOCIETE ADRESSE COMPTE 1#]",
        "[#SOCIETE COMPTE 2#]",
        "[#SOCIETE ADRESSE COMPTE 2#]",
    ];

    const rawWorkerVariables = [
        "[#MATRICULE#]",
        "[#STATUT#]",
        "[#NOM#]",
        "[#PRENOM#]",
        "[#DATE NAISSANCE#]",
        "[#LIEU NAISSANCE#]",
        "[#SEXE#]",
        "[#SITUATION FAMILIALE#]",
        "[#DATE MARIAGE#]",
        "[#ADRESSE#]",
        "[#ADRESSE COMPLETE#]",
        "[#TÉLÉPHONE PERSONNEL#]",
        "[#TÉLÉPHONE PROFESSIONNEL#]",
        "[#EMAIL#]",
        "[#FONCTION#]",
        "[#ORGANIGRAMME#]",
        "[#SOCIO PROFESSIONNELLE#]",
        "[#GRILLE#]",
        "[#RESPONSABLE HIERARCHIQUE#]",
        "[#DATE DE RECRUTEMENT#]",
        "[#SOCIETE DE DECLARATION#]",
        "[#LIEUX DE TRAVAIL#]",
        "[#ETAT EMPLOYE#]",
        "[#DATE SORTIE#]",
        "[#MOTIF DE SORTIE#]",
        "[#NUMERO SECURITE SOCIALE#]",
        "[#NUMERO MUTUELLE#]",
        "[#NUMERO CARTE SHIFA#]",
        "[#NUMERO COMPTE BANQUAIRE#]",
        "[#NUMERO CCP#]",
        "[#PRÉNOM PÈRE#]",
        "[#DATE NAISSANCE PÈRE#]",
        "[#NOM MÈRE#]",
        "[#PRENOM MÈRE#]",
        "[#DATE NAISSANCE MÈRE#]",
        "[#AGENCE CNAS#]"

        // "[#NOM EN ARAB#]",
        // "[#PRENOM EN ARAB#]",
        // "[#FONCTION EN ARAB#]",
        // "[#ORGANIGRAMME EN ARAB#]",
        // "[#LIEU NAISSANCE EN ARAB#]",
        //  "[#ADRESSE EN ARAB#]",
    ];

    const workerVariables = [
        ...variables,
         "[#CIVILITE#]",
        ...rawWorkerVariables,
    ];

    const contratVariables = [
        ...workerVariables,
        "[#NUMERO CONTRAT#]",
        "[#ETAT CONTRAT#]",
        "[#MODELE CONTRAT#]",
        "[#DATE SIGNATURE#]",
        "[#DATE DEBUT#]",
        "[#DATE FIN#]",
        "[#DUREE#]",
        "[#CARACTRISTIQUE CONTRAT#]",
        "[#DUREE PERIODE D'ESSAI#]",
        "[#FIN PERIODE D'ESSAI#]",
        "[#ETAT PERIODE D'ESSAI#]",
        "[#RENOUVELLER JUSQ'AU#]",
        "[#RAISON DE DEPART#]",
        "[#DATE RESILIATION#]",
    ];

    const debtVariables = [
        ...workerVariables,
        "[#DATE#]",
        "[#DEBUT REMBOURSEMENT#]",
        "[#MONTANT#]",
        "[#DUREE#]",
        "[#REMBOURSE#]",
        "[#RESTE#]",
    ];

    const recruitmentRequestVariables = [
        ...workerVariables,
        "[#NUMERO DEMANDE#]",
        "[#SERVICE DEMANDEUR#]",
        "[#POSTE#]",
        "[#NOMBRE POSTE#]",
        "[#MOTIF#]",
        "[#SCOPE#]",
        "[#BUDGET#]",
        "[#DATE RECRUTEMENT#]",
    ];

    const recruitmentPlanningVariables = [
        ...recruitmentRequestVariables,
        "[#DATE ENTRETIEN#]",
        "[#TYPE ENTRETIEN#]",
        "[#HEURE DEBUT ENTRETIEN#]"
    ];

    const recruitmentCvTechSourcingVariables = [
        "[#CANDIDAT PRENOM#]",
        "[#CANDIDAT NOM#]",
        "[#CANDIDAT DATE NAISSANCE#]",
        "[#CANDIDAT EMAIL#]",
        "[#CANDIDAT PHONE#]",
        "[#CANDIDAT ADRESSE#]",
        "[#CANDIDAT CIVILITE#]",
    ];

    const recruitmentCandidateVariables = [
        ...recruitmentPlanningVariables,
        ...recruitmentCvTechSourcingVariables,
        "[#HEURE ENTRETIEN#]",
    ];

    const boardingVariables = [
        ...workerVariables,
        "[#MODELE#]",
        "[#CATEGORIE#]",
        "[#DATE_EFFET#]",
        "[#BOARDING_STATUS#]",
        "[#DATE_DEBUT_PREVISIONNELLE#]",
        "[#DATE_FIN_PREVISIONNELLE#]",
        "[#BOARDING_DATE_DEBUT#]",
        "[#BOARDING_DATE_FIN#]",
    ];

    const boardingTaskVariables = [
        ...boardingVariables,
        "[#TACHE#]",
        "[#DESTINATAIRE#]",
        "[#INSTRUCTION#]",
        "[#TACHE_STATUS#]",
        "[#TACHE_DATE_DEBUT#]",
        "[#TACHE_DATE_FIN#]",
    ];

    const evaluationPlanVariables = [
        ...workerVariables,
        "[#NOM_EVALUATION#]",
        "[#DATE_DEBUT#]",
        "[#DATE_FIN#]"
    ];

    const evaluationCandidateVariables = [
        ...workerVariables,
        "[#NOM_EVALUATION#]",
        "[#DATE_DEBUT#]",
        "[#DATE_FIN#]",
        "[#DATE#]",
        "[#HEURE#]",
        "[#LIEN_AUTO_EVALUATION#]"
    ];

    const medicalCompanionVariables = [
        ...variables,
        "[#CODE#]",
        "[#LIBELLE#]",
        "[#DATE_DEBUT#]",
        "[#DATE_FIN#]",
        "[#MOTIF_MEDICALE#]",
        "[#CENTRE_MEDICALE#]",
    ];

    const medicalAppointmentVariables = [
        ...workerVariables,
        "[#DATE#]",
        "[#HEURE#]",
        "[#ETAT#]",
        "[#RESULTAT#]",
        "[#MOTIF_MEDICALE#]",
        "[#CENTRE_MEDICALE#]",
    ]

    const regimeVariables = [
        ...variables,
        "[#NUMERO#]",
        "[#DATE DEBUT#]",
        "[#DATE FIN#]",
        "[#DATE JOUR#]",
        "[#SANCTION#]",
        "[#FAUTES#]",
    ];

    const sex = [
        {id: 'M', name: $i18n.t('worker.sex.M')},
        {id: 'F', name: $i18n.t('worker.sex.F')},
    ];

    const validatorTypes = [
        {id: 'SPECIFIC', name: 'Spécifique'},
        {id: 'RESPONSIBLE', name: 'Responsable Hiérarchique'},
        {id: 'SERVICE', name: 'Service'},
    ];

    const daysOfMonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,];

    const modesIrg = [
        {id: 'NORMAL', name: $i18n.t('mode_irg.NORMAL')},
        {id: 'HANDICAPPED', name: $i18n.t('mode_irg.HANDICAPPED')},
        {id: 'CUT_25_PERCENT', name: $i18n.t('mode_irg.CUT_25_PERCENT')},
        {id: 'CUT_50_PERCENT', name: $i18n.t('mode_irg.CUT_50_PERCENT')},
        {id: 'EXEMPT', name: $i18n.t('mode_irg.EXEMPT')},
    ];

    const paySectionPositions = ['FIX', 'VARIABLE', 'RESULT'];

    const pagination = [
        {id: 5, name: '5'},
        {id: 10, name: '10'},
        {id: 15, name: '15'},
        {id: 20, name: '20'},
        {id: 25, name: '25'},
        {id: 30, name: '30'},
        {id: 2147483647, name: 'Tous'},
    ];

    const paySlipPeriodicities = [
        {id: 'QUARTER_1', name: 'Trimestre 1'},
        {id: 'QUARTER_2', name: 'Trimestre 2'},
        {id: 'QUARTER_3', name: 'Trimestre 3'},
        {id: 'QUARTER_4', name: 'Trimestre 4'},
        {id: 'SEMESTER_1', name: 'Semestre 1'},
        {id: 'SEMESTER_2', name: 'Semestre 2'},
        {id: 'YEAR', name: 'Année'},
        {id: 'SPECIFIC', name: 'Spécifique'},
    ];

    const itemsPerPageList = [
        {id: 5, name: '5'},
        {id: 10, name: '10'},
        {id: 15, name: '15'},
        {id: 20, name: '20'},
        {id: 25, name: '25'},
        {id: 30, name: '30'},
        {id: 2147483647, name: 'Tous'},
    ];

    const balancePaySlipIncreaseOptions = [
        {id: 'PAY_SLIP_ANNEX_VALIDATE', name: $i18n.t('balance.PAY_SLIP_ANNEX_VALIDATE')},
        {id: 'PAY_SLIP_ANNEX_CLOSED', name: $i18n.t('balance.PAY_SLIP_ANNEX_CLOSED')},
        {id: 'PAY_SLIP_CLOSED', name: $i18n.t('balance.PAY_SLIP_CLOSED')},
    ]

    const restStates = [
        {id: 'WAITING', name: $i18n.t('debts.WAITING')},
        {id: 'IN_PROGRESS', name: $i18n.t('debts.IN_PROGRESS')},
        {id: 'CLOSED', name: $i18n.t('debts.CLOSED')},
    ];

    const trainingScorecardTypes = [
        {id: "HOT", name: $i18n.t('training.scorecard_type_HOT')},
        {id: "COLD", name: $i18n.t('training.scorecard_type_COLD')},
    ];

    const questionTypes = [
        {id: "NUMBER", name: $i18n.t('training.question_type_NUMBER')},
        {id: "DATE", name: $i18n.t('training.question_type_DATE')},
        {id: "DATE_TIME", name: $i18n.t('training.question_type_DATE_TIME')},
        {id: "TIME", name: $i18n.t('training.question_type_TIME')},
        {id: "TEXT", name: $i18n.t('training.question_type_TEXT')},
        {id: "TRUE_FALSE", name: $i18n.t('training.question_type_TRUE_FALSE')},
        {id: "TRUE_FALSE_WITH_EXPLAIN", name: $i18n.t('training.question_type_TRUE_FALSE_WITH_EXPLAIN')},
        {id: "SELECT", name: $i18n.t('training.question_type_SELECT')},
        {id: "SELECT_TYPE", name: $i18n.t('training.question_type_SELECT_TYPE')},
        {id: "DATE_INTERVAL", name: $i18n.t('training.question_type_DATE_INTERVAL')},
        {id: "DATE_TIME_INTERVAL", name: $i18n.t('training.question_type_DATE_TIME_INTERVAL')},
        {id: "TIME_INTERVAL", name: $i18n.t('training.question_type_TIME_INTERVAL')},
    ];

    const evaluationEvaluatorTypes = [
        {id: "AUTO_EVALUATION", name: $i18n.t('evaluation.AUTO_EVALUATION')},
        {id: "MANAGER", name: $i18n.t('evaluation.MANAGER')},
        {id: "SPECIFIC", name: $i18n.t('evaluation.SPECIFIC')},
    ];

    const evaluationCycles = [
        {id: "MONTHLY", name: $i18n.t('evaluation.MONTHLY')},
        {id: "QUARTERLY", name: $i18n.t('evaluation.QUARTERLY')},
        {id: "HALF_YEARLY", name: $i18n.t('evaluation.HALF_YEARLY')},
        {id: "YEARLY", name: $i18n.t('evaluation.YEARLY')},
        // {id: "SPECIFIC", name: $i18n.t('evaluation.SPECIFIC')},
    ];

    const trainingPeriods = [
        {id: "MONTHLY", name: $i18n.t('training.MONTHLY')},
        {id: "QUARTERLY", name: $i18n.t('training.QUARTERLY')},
        {id: "HALF_YEARLY", name: $i18n.t('training.HALF_YEARLY')},
        {id: "YEARLY,", name: $i18n.t('training.YEARLY,')},
        {id: "SPECIFIC", name: $i18n.t('training.SPECIFIC')},
    ];

    const quarterlies = [
        {id: 1, name: $i18n.t('common.QUARTERLY_1')},
        {id: 2, name: $i18n.t('common.QUARTERLY_2')},
        {id: 3, name: $i18n.t('common.QUARTERLY_3')},
        {id: 4, name: $i18n.t('common.QUARTERLY_4')},
    ];

    const halfYearlies = [
        {id: 1, name: $i18n.t('common.HALF_YEARLY_1')},
        {id: 2, name: $i18n.t('common.HALF_YEARLY_2')},
    ];

    const months = [
        {id: 'JANUARY', name: $i18n.t('common.JANUARY')},
        {id: 'FEBRUARY', name: $i18n.t('common.FEBRUARY')},
        {id: 'MARCH', name: $i18n.t('common.MARCH')},
        {id: 'APRIL', name: $i18n.t('common.APRIL')},
        {id: 'MAY', name: $i18n.t('common.MAY')},
        {id: 'JUNE', name: $i18n.t('common.JUNE')},
        {id: 'JULY', name: $i18n.t('common.JULY')},
        {id: 'AUGUST', name: $i18n.t('common.AUGUST')},
        {id: 'SEPTEMBER', name: $i18n.t('common.SEPTEMBER')},
        {id: 'OCTOBER', name: $i18n.t('common.OCTOBER')},
        {id: 'NOVEMBER', name: $i18n.t('common.NOVEMBER')},
        {id: 'DECEMBER', name: $i18n.t('common.DECEMBER')},
    ];

    const atsModes = [
        {id: 'MONTH_NUMBER', name: $i18n.t('worker.ats.MONTH_NUMBER')},
        {id: 'PAY_SECTION', name: $i18n.t('worker.ats.PAY_SECTION')},
    ]

    const documentModules = [
        {id: 'RECRUITMENT_REQUEST', documentDatabaseId: -54, name: $i18n.t('modules.RECRUITMENT_REQUEST')},
        {id: 'ON_BOARDING', documentDatabaseId: -53, name: $i18n.t('modules.ON_BOARDING')},
        {id: 'OFF_BOARDING', documentDatabaseId: -52, name: $i18n.t('modules.OFF_BOARDING')},
        {id: 'WORKER', documentDatabaseId: -79, name: $i18n.t('modules.WORKER')},
        {id: 'CONTRAT', documentDatabaseId: -77, name: $i18n.t('modules.CONTRAT')},
        {id: 'CONTRAT_TEMPLATE', documentDatabaseId: -56, name: $i18n.t('modules.CONTRAT_TEMPLATE')},
        {id: 'VACATION', documentDatabaseId: -75, name: $i18n.t('modules.VACATION')},
        {id: 'DEBT', documentDatabaseId: -73, name: $i18n.t('modules.DEBT')},
        {id: 'PAY_DAY_ADVANCE', documentDatabaseId: -72, name: $i18n.t('modules.PAY_DAY_ADVANCE')},
        {id: 'PAY_SLIP', documentDatabaseId: -70, name: $i18n.t('modules.PAY_SLIP')},
        {id: 'PAY_SLIP_ANNEX', documentDatabaseId: -69, name: $i18n.t('modules.PAY_SLIP_ANNEX')},
        {id: 'TRAINING_REQUEST', documentDatabaseId: -67, name: $i18n.t('modules.TRAINING_REQUEST')},
        {id: 'TRAINING_SESSION', documentDatabaseId: -66, name: $i18n.t('modules.TRAINING_SESSION')},
        {id: 'ABSENCE_REQUEST', documentDatabaseId: -64, name: $i18n.t('modules.ABSENCE_REQUEST')},
        {id: 'CLAIM', documentDatabaseId: -63, name: $i18n.t('modules.CLAIM')},
        {id: 'ADMIN_REQUEST', documentDatabaseId: -62, name: $i18n.t('modules.ADMIN_REQUEST')},
        {id: 'EVALUATION_SKILL', documentDatabaseId: -50, name: $i18n.t('modules.EVALUATION_SKILL')},
        {id: 'EVALUATION_PERFORMANCE', documentDatabaseId: -49, name: $i18n.t('modules.EVALUATION_PERFORMANCE')},
        {id: 'MEDICAL_COMPANION', documentDatabaseId: -49, name: $i18n.t('modules.MEDICAL_COMPANION')},
        {id: 'MEDICAL_APPOINTMENT', documentDatabaseId: -49, name: $i18n.t('modules.MEDICAL_APPOINTMENT')},
    ];

    const outStateModelFiles = [
        {id: "PAY_SLIP", name: $i18n.t('out_state_model.PAY_SLIP'), file: 'BULLETIN_PAIE.jrxml'},
        // {id: "RECAP", name: $i18n.t('out_state_model.RECAP'), file: 'ETAT_RECAPITULATIF.jrxml'},
        {id: "TRANSFER_ORDER", name: $i18n.t('out_state_model.TRANSFER_ORDER'), file: 'TransferOrder.jrxml'},
        {id: "WORKER_IN_OUT", name: $i18n.t('out_state_model.WORKER_IN_OUT'), file: 'WorkerInOut.jrxml'},
        {id: "VACATION_TITLE", name: $i18n.t('out_state_model.VACATION_TITLE'), file: 'VACATION_TITLE.jrxml'}
    ];

    const personalizedVariableTypes = [
        {id: "PRICE", name: $i18n.t('personalized_variable.type.PRICE')},
        {id: "DATE", name: $i18n.t('personalized_variable.type.DATE')},
        {id: "TIME", name: $i18n.t('personalized_variable.type.TIME')},
        {id: "MONTH", name: $i18n.t('personalized_variable.type.MONTH')},
        {id: "TEXT", name: $i18n.t('personalized_variable.type.TEXT')},
        {id: "NUMBER", name: $i18n.t('personalized_variable.type.NUMBER')},
    ];

    const paySectionEasyCreateTypes = [
        {id: "SIMPLE_GAIN", name: $i18n.t('pay_section.easy_create.SIMPLE_GAIN')},
        {id: "SIMPLE_RETENUE", name: $i18n.t('pay_section.easy_create.SIMPLE_RETENUE')},
        {id: "PRC_BASE_SALARY", name: $i18n.t('pay_section.easy_create.PRC_BASE_SALARY')},
        {id: "NOMBRE_X_TAUX", name: $i18n.t('pay_section.easy_create.NOMBRE_X_TAUX')},
        {id: "BASE_X_PRC", name: $i18n.t('pay_section.easy_create.BASE_X_PRC')},
        {id: "NOMBRE_X_BASE", name: $i18n.t('pay_section.easy_create.NOMBRE_X_BASE')},
        {id: "BASE_X_PRORATA_ABSENCE", name: $i18n.t('pay_section.easy_create.BASE_X_PRORATA_ABSENCE')},
        {id: "ABSENCE_IN_DAYS", name: $i18n.t('pay_section.easy_create.ABSENCE_IN_DAYS')},
        {id: "ABSENCE_IN_HOURS", name: $i18n.t('pay_section.easy_create.ABSENCE_IN_HOURS')},
    ];

    const evaluationFileDisplayModes = [
        {id: "LISTING", name: $i18n.t('evaluation.file_display_mode_LISTING')},
        {id: "FILE", name: $i18n.t('evaluation.file_display_mode_FILE')},
    ];

    const evaluationFileScopes = [
        {id: "OCCUPATION", name: $i18n.t('evaluation.file_scope_OCCUPATION')},
        {id: "WORKER", name: $i18n.t('evaluation.file_scope_WORKER')},
    ];

    const evaluationFileTypes = [
        {id: "EVALUATION_PERFORMANCE", name: $i18n.t('evaluation.file_type_EVALUATION_PERFORMANCE')},
        {id: "EVALUATION_SKILL", name: $i18n.t('evaluation.file_type_EVALUATION_SKILL')},
        {id: "EVALUATION_RECRUITMENT", name: $i18n.t('evaluation.file_type_EVALUATION_RECRUITMENT')},
        {id: "EVALUATION_TRAINING_HOT", name: $i18n.t('evaluation.file_type_EVALUATION_TRAINING_HOT')},
        {id: "EVALUATION_TRAINING_COLD", name: $i18n.t('evaluation.file_type_EVALUATION_TRAINING_COLD')},
    ];

    return {
        evaluationFileTypes,
        evaluationFileScopes,
        evaluationFileDisplayModes,
        personalizedVariableTypes,
        outStateModelFiles,
        documentModules,
        atsModes,
        months,
        quarterlies,
        halfYearlies,
        evaluationEvaluatorTypes,
        evaluationCycles,
        trainingPeriods,
        questionTypes,
        trainingScorecardTypes,
        restStates,
        balancePaySlipIncreaseOptions,
        itemsPerPageList,
        paySlipPeriodicities,
        pagination,
        paySectionPositions,
        modesIrg,
        daysOfMonth,
        sex,
        variables,
        rawWorkerVariables,
        workerVariables,
        contratVariables,
        evaluationPlanVariables,
        evaluationCandidateVariables,
        regimeVariables,
        debtVariables,
        recruitmentRequestVariables,
        recruitmentPlanningVariables,
        recruitmentCvTechSourcingVariables,
        recruitmentCandidateVariables,
        boardingVariables,
        boardingTaskVariables,
        medicalCompanionVariables,
        medicalAppointmentVariables,
        inputModes,
        requestStatus,
        contratStatus,
        contratTrialPeriodStatus,
        decisionStatus,
        workerStates,
        workerPhases,
        profiles,
        transferModes,
        simpleOperators,
        operations,
        simpleOperations,
        yesOrNoArray,
        periodicity,
        simplePeriodicity,
        operators,
        dataSelectModules,
        dataSelectTypes,
        careBeneficiaries,
        importModelTypes,
        validationWorkFlowStatus,
        workFlowModules,
        recruitmentStates,
        recruitmentExpertDecisions,
        boardingCategories,
        boardingChronologies,
        boardingExecutions,
        boardingStatus,
        cvTechSourcingStates,
        recruitmentEvaluationDecisions,
        recruitmentScopes,
        validatorTypes,
        paySectionEasyCreateTypes,
    }
}